module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "ch1"
    }
  }), _vm._v("CHAPTER 1")]), _vm._v(" "), _c('h2', {
    staticClass: "h2a"
  }, [_vm._v("BREAKING IT DOWN")]), _vm._v(" "), _c('h2', {
    staticClass: "h2b"
  }, [_vm._v("Candy-Bar Elements, Ingredients, and Tools")]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01a#ch1lev1"
    }
  }, [_c('span', {
    staticClass: "brown"
  }, [_c('span', {
    staticClass: "strong1"
  }, [_vm._v("What Is a Candy Bar—and What Should Be in It?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01b#ch1lev2"
    }
  }, [_c('span', {
    staticClass: "brown"
  }, [_c('span', {
    staticClass: "strong1"
  }, [_vm._v("The Sweet Life: Then and Now")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01c#ch1lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "brown"
  }, [_c('span', {
    staticClass: "strong1"
  }, [_vm._v("The Artisan Option")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01d#ch1lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "brown"
  }, [_c('span', {
    staticClass: "strong1"
  }, [_vm._v("Candy-Bar Toolbox")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3574bc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter01.vue
// module id = 84
// module chunks = 0